<template>
	<li class="app-description-list__item">{{ message }}</li>
</template>

<script>
export default {
	props: {
		message: {
			type: String,
			required: true,
		},
	},
};
</script>
